import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ContentfulService } from '../services/contentful/contentful.service';
import { Entry } from 'contentful';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContentResolver implements Resolve<Entry<any> | undefined> {
  constructor(private contentfulService: ContentfulService) {}

  resolve(next: ActivatedRouteSnapshot) {
    const contentId = next.data.contentId;
    return contentId
      ? this.contentfulService.getPage(contentId).pipe(first())
      : undefined;
  }
}
